import { IUserCalendar } from '@commenda/types/src/user';
import React from 'react';
import CalendarSideNavBooking from './calendar-sidenav-booking';
import CalendarSideNavMobile from './calendar-sidenv-mobile';

const CalendarHOCBooking = ({
  children,
  data,
}: {
  children: React.ReactNode;
  data: IUserCalendar;
}) => {
  return (
    <>
      <CalendarSideNavMobile data={data}>{children}</CalendarSideNavMobile>
      <CalendarSideNavBooking data={data}>{children}</CalendarSideNavBooking>
    </>
  );
};

export default CalendarHOCBooking;
